import { Checkbox } from 'primereact/checkbox';
import { ClassAttributeType } from '../../../../../api/types/settings/class-attributes/class-attribute-types';
import { EditText } from '../../../../../component/ui/edit-text/edit-text';
import { Button } from 'primereact/button';
import React, { useState } from 'react';
import { addClassAttributeToExistingListOperation } from './operations/add-class-attribute-to-existing-list.operation';

interface AddAttributeToExistingListDataModel {
  listId?: number;
  onHilde: () => any;
}

export const AddAttributeToExistingList: React.FC<
  AddAttributeToExistingListDataModel
> = ({ listId, onHilde }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [newAttributeName, setNewAttributeName] = useState('');

  const [selectedAttribute, setSelectedAttribute] =
    useState<ClassAttributeType | null>(null);

  const handleAddNewAttribute = async () => {
    await addClassAttributeToExistingListOperation(
      listId,
      selectedAttribute,
      newAttributeName,
      onHilde,
    );
  };

  return (
    <div className="flex flex-column gap-3">
      <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Checkbox
            inputId="ingredient1"
            name="pizza"
            value=""
            onChange={() => setSelectedAttribute(ClassAttributeType.Bool)}
            checked={selectedAttribute === ClassAttributeType.Bool}
          />
          <label
            style={{ marginRight: '4px' }}
            htmlFor="ingredient1"
            className="ml-2"
          >
            בוליאני
          </label>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Checkbox
            inputId="ingredient1"
            name="pizza"
            value=""
            onChange={() => setSelectedAttribute(ClassAttributeType.Numeric)}
            checked={selectedAttribute === ClassAttributeType.Numeric}
          />
          <label
            style={{ marginRight: '4px' }}
            htmlFor="ingredient1"
            className="ml-2"
          >
            מספרי
          </label>
        </div>
      </div>
      <EditText
        title="שם המאפיין"
        value={newAttributeName}
        onChange={(str) => setNewAttributeName(str)}
      />

      <div className="flex justify-content-end gap-2">
        <Button label="ביטול" onClick={onHilde} className="p-button-text" />
        <Button
          label="אישור"
          onClick={() => handleAddNewAttribute()}
          loading={isLoading}
        />
      </div>
    </div>
  );
};
